export default __webpack_public_path__ + "static/media/logo_fundacion.3c32311d.png";